import { QueryMapModel } from './query.model';

export class MapConfiguration {
  Name: string;
  WebApiUrl: string;
  ReadMapMessage: QueryMapModel;
  DefaultExtent: number[];
  InitialExtent: number[];
  ImageVectorScaleLimit: number;
  MinScaleLimit: number;
  CacheFilterExpression: string;
}
